import { config } from 'env_def';
import moment from 'moment';
import lodashGet from 'lodash/get';
import { apis, environment, inWindow } from '@/config';
import { api } from '@/api/api';
import { platform } from '@/api/util/platform';
import { locationHelper } from '@/api/util/location_helper';
import { getOs } from '../../../utils/confOs';
import { compressItem } from './compress_item';
const forElectron = config('build_for') === 'electron';
const isMac = getOs() === 'mac';
const electronKey = isMac ? ['HubbleMacKey', 'OxpeckerMacKey'] : ['HubbleWinKey', 'OxpeckerWinKey'];
const confKey = forElectron ? electronKey : ['HubbleWebKey', 'OxpeckerWebKey'];
const appkey = config(confKey[0]);
const oxpeckerKey = config(confKey[1]);
const oxpeckerHost = config('OxpeckerHost');
const env = typeof environment === 'string' ? environment : 'local';
const isDev = !['test_prod', 'prod', 'prev', 'test', 'dev'].includes(env);
const isLocal = inWindow() ? window.location.href.includes('su-desktop-web.cowork.netease.com:8000') : true;
console.log('[data-tracker] dataTrackerApiImp stage', isDev, env);
const DATA_TRACK_PREFIX = 'track_limit_';
const SYNC_NUM_DEFAULT = 2;
let mailStats;
class DataTrackerApiImp {
    constructor() {
        this.waitTrackList = [];
        this.limitMap = new Map();
        this.compressList = {};
        this.eventIdNumObj = {};
        this.islowmemorymode = false;
        this.trackCommonOption = {
            deviceId: '',
            domain: '',
            orgName: '',
            orgId: 0,
            threadMode: 'off',
            userAccount: '',
            qiyeAccountId: '',
            logginStatus: 'false',
        };
        this.name = apis.dataTrackerApiImp;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.mailConf = api.requireLogicalApi(apis.mailConfApiImpl);
        this.loginApi = api.requireLogicalApi(apis.loginApiImpl);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.updateAttributes = this.updateAttributes.bind(this);
        this.initCompress();
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return user === null || user === void 0 ? void 0 : user.id;
    }
    getDomain() {
        const user = this.systemApi.getCurrentUser();
        return user === null || user === void 0 ? void 0 : user.domain;
    }
    init() {
        this.systemApi.getDeviceInfo().then(value => {
            this.deviceInfo = value;
        });
        return this.name;
    }
    afterInit() {
        console.warn('[data-tracker] window.DATracker', window.DATracker, appkey);
        if (inWindow() && (!window.DATracker || !window.DATracker.__loaded)) {
            window.DATracker.init(appkey, {
                truncateLength: 255,
                persistence: 'localStorage',
                cross_subdomain_cookie: false,
            });
            window.DATracker.oxpecker_init(oxpeckerKey);
            window.DATracker.oxpecker_set_base_attributes({
                _version: window.getSpConf('version'),
            });
        }
        this.initMailStats();
        const userId = this.getEmail();
        this.systemApi.getIsLowMemoryMode().then(flag => {
            this.islowmemorymode = flag;
        });
        if (userId) {
            this.login();
        }
        else {
            this.logoutHandle();
        }
        window.DATracker.oxpecker_set_url({
            baseUrl: `${oxpeckerHost}/api/pub/event/tracking`,
            beaconUrl: `${oxpeckerHost}/api/pub/event/send-beacon/tracking`,
            isNewUrl: `${oxpeckerHost}/api/pub/user-active`,
        });
        if (!locationHelper.isMainPage()) {
            const eid = this.eventApi.registerSysEventObserver('setDATrackerToken', {
                func: (e) => {
                    const token = lodashGet(e, 'eventData.token', '');
                    if (token && token.length) {
                        this.setToken(token);
                        this.eventApi.unregisterSysEventObserver('setDATrackerToken', eid);
                    }
                },
            });
        }
        if (this.waitTrackList.length) {
            this.waitTrackList.forEach(item => {
                this.track(item.eventId, item.attributes);
            });
        }
        this.eventApi.registerSysEventObserver('updateUserInfo', {
            func: () => {
                this.loginHandle();
            },
        });
        this.eventApi.registerSysEventObserver('toMuchOrToSlowLogger', {
            func: ev => {
                this.track('toMuchOrToSlowLogger', ev.eventData || {}, true);
            },
        });
        return this.name;
    }
    initMailStats() {
        var _a;
        if (window.MailStats) {
            try {
                window.MailStats.prototype.getIpInfo = function () {
                    return new Promise((resolve, reject) => {
                        reject();
                    });
                };
                const userId = this.getEmail();
                mailStats = new window.MailStats({
                    dataSource: ((_a = config('profile')) === null || _a === void 0 ? void 0 : _a.startsWith('webmail')) ? 'qiye' : 'mail',
                    interval: 1000,
                    enableSqlServer: false,
                    enableCrossTabMessaging: false,
                });
                mailStats.config({
                    application: 'free_lingxi_b128704673ec1ac8',
                    appVersion: window.getSpConf('version'),
                    uid: userId,
                    account: userId,
                    options: {
                        useHttps: true,
                        isSpa: false,
                        autoReadUid: false,
                        autoAddKeyInfo: false,
                    },
                });
            }
            catch (error) {
                console.error('initMailStats error', error);
            }
        }
    }
    async syncCompressList() {
        try {
            const compressListString = this.storeApi.getSync('compressListString', { noneUserRelated: true });
            if (compressListString && compressListString.suc && compressListString.data && Object.keys(JSON.parse(compressListString.data)).length) {
                const compressList = JSON.parse(compressListString.data);
                this.compressList = compressList;
            }
            console.log('compressListString', compressListString);
        }
        catch (ex) {
            console.error('compressListString', ex);
        }
    }
    async initCompress() {
        if (isDev) {
            return;
        }
        this.initCompressTimer = setInterval(() => {
            this.compressUpload();
        }, 60 * 60 * 1000);
        inWindow() &&
            window.addEventListener('beforeunload', () => {
                if (!location.pathname.includes('login')) {
                    const compressListString = JSON.stringify(this.compressList);
                    this.storeApi.putSync('compressListString', compressListString, { noneUserRelated: true });
                }
            });
    }
    async compressUpload() {
        for (const eventId in this.compressList) {
            if (this.compressList[eventId].trackCount > 0) {
                console.log('compressUpload', eventId, this.compressList[eventId].trackCount);
                this.track(eventId, {}, false, true);
                this.compressList[eventId].trackCount = 0;
                await new Promise(res => setTimeout(res, 1000));
            }
        }
    }
    getCurrentVersion() {
        return inWindow() && window.electronLib && window.electronLib.env ? window.electronLib.env.showVersion : config('version');
    }
    getUUId() {
        const sync = this.storeApi.getSync(DataTrackerApiImp.keyDeviceUUID);
        const uuid = sync && sync.suc && sync.data ? sync.data : '';
        return uuid;
    }
    logoutHandle() {
        var _a;
        clearInterval(this.initCompressTimer);
        console.log('compressUpload -- logoutHandle');
        const currentVersion = this.getCurrentVersion();
        const uuid = this.getUUId();
        const deviceId = ((_a = this.deviceInfo) === null || _a === void 0 ? void 0 : _a._deviceId) || '';
        this.trackCommonOption = {
            deviceId,
            domain: '',
            orgName: '',
            orgId: 0,
            threadMode: 'off',
            userAccount: '',
            qiyeAccountId: '',
            logginStatus: 'false',
        };
        this.updateAttributes({
            deviceId,
            domain: '',
            orgName: '',
            threadMode: 'off',
            userAccount: '',
            logginStatus: false,
            uuid,
            version: currentVersion,
            platform: platform.isMobile() ? 'h5' : 'web',
            app: platform.getMobileApp(),
        });
    }
    loginHandle() {
        var _a, _b, _c;
        this.syncCompressList();
        const user = this.systemApi.getCurrentUser();
        const companyId = this.systemApi.getCurrentCompanyId();
        const orgName = (user === null || user === void 0 ? void 0 : user.company) || '';
        const domain = (user === null || user === void 0 ? void 0 : user.domain) || '';
        const threadMode = this.mailConf.getMailMergeSettings();
        const userAccount = user === null || user === void 0 ? void 0 : user.id;
        const logginStatus = true;
        const deviceId = ((_a = this.deviceInfo) === null || _a === void 0 ? void 0 : _a._deviceId) || '';
        const uuid = this.getUUId();
        const version = this.getCurrentVersion();
        this.trackCommonOption = {
            deviceId,
            domain,
            orgName,
            orgId: companyId,
            threadMode,
            userAccount: (user === null || user === void 0 ? void 0 : user.accountMd5) || '',
            qiyeAccountId: ((_c = (_b = user === null || user === void 0 ? void 0 : user.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.id) || '',
            logginStatus: '' + logginStatus,
        };
        this.updateAttributes({
            deviceId,
            domain,
            orgName,
            threadMode,
            userAccount,
            logginStatus,
            uuid,
            version,
            platform: platform.isMobile() ? 'h5' : 'web',
            app: platform.getMobileApp(),
        });
    }
    afterLogin() {
        this.login();
        return this.name;
    }
    beforeLogout() {
        this.logoutHandle();
        this.logout();
        return this.name;
    }
    login() {
        try {
            this.loginHandle();
        }
        catch (ex) {
            console.error('loginHandle-catch', ex);
        }
        const userId = this.getEmail();
        window.DATracker.login(userId);
    }
    logout() {
        window.DATracker.logout();
    }
    track(eventId, attributes, noPopup, compress) {
        var _a;
        if (!inWindow()) {
            return;
        }
        console.log(eventId, attributes);
        if (isDev || isLocal) {
            return;
        }
        const { enableTrackInBg = false, _account, recordSubAccount = true } = attributes || { enableTrackInBg: false, recordSubAccount: true };
        if (inWindow() && window.isBridgeWorker && !enableTrackInBg) {
            return;
        }
        const mainAccount = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        const accountType = _account && _account !== mainAccount ? 'sub' : 'main';
        if (accountType === 'sub' && !recordSubAccount) {
            return;
        }
        try {
            if (this.canTrack(eventId)) {
                if (!noPopup)
                    this.loggerApi.track(eventId, attributes, 'high');
                if (compressItem.includes(eventId)) {
                    if (!this.compressList[eventId]) {
                        this.compressList[eventId] = { trackCount: 0 };
                    }
                }
                const compressEventId = this.compressList[eventId];
                const compressAttribute = {};
                if (compressEventId) {
                    if (compress) {
                        compressEventId.trackCount -= 1;
                    }
                    else {
                        compressEventId.trackCount += 1;
                    }
                    compressAttribute.trackCount = compressEventId.trackCount;
                    if (compressEventId.trackCount > 1 && !compress) {
                        return;
                    }
                }
                if (mailStats) {
                    try {
                        mailStats.data(eventId, Object.assign(Object.assign(Object.assign({}, (attributes || {})), { islowmemorymode: this.islowmemorymode, operationaccount: attributes === null || attributes === void 0 ? void 0 : attributes._account, acountType: accountType }), compressAttribute));
                    }
                    catch (error) {
                        console.error('mailStats.data error', error);
                    }
                }
                if (window.DATracker && window.DATracker.track) {
                    window.DATracker.track(eventId, Object.assign(attributes || {}, {
                        islowmemorymode: this.islowmemorymode,
                        operationaccount: attributes === null || attributes === void 0 ? void 0 : attributes._account,
                        acountType: accountType,
                    }, compressAttribute));
                }
                else {
                    this.waitTrackList.push({
                        eventId,
                        attributes,
                    });
                }
            }
        }
        catch (ex) {
            console.log('[track_impl]track.error', ex);
        }
    }
    initLimit(eventId, limitNum, syncNum) {
        if (limitNum <= 0) {
            console.log('[data-traker] initLimit number must above 0');
            return;
        }
        const defaultSyncNum = Math.max(Math.ceil(limitNum / 3), SYNC_NUM_DEFAULT);
        this.limitMap.set(eventId, [limitNum, syncNum || defaultSyncNum]);
    }
    canTrack(eventId) {
        const limit = this.limitMap.has(eventId) && this.limitMap.get(eventId);
        if (limit) {
            const nowNum = this.getLimitNum(eventId);
            this.setLimitNum(eventId, nowNum + 1);
            if (nowNum >= limit[0]) {
                return false;
            }
        }
        return true;
    }
    getLimitNum(eventId) {
        let result = 0;
        const nowArr = this.eventIdNumObj[eventId];
        if (nowArr && nowArr.length) {
            const dayStr = moment().format('YYYY-MM-DD');
            if (dayStr === nowArr[0]) {
                result = nowArr[1];
            }
            else {
                result = 0;
            }
            const limit = this.limitMap.has(eventId) && this.limitMap.get(eventId);
            const syncNum = limit && limit[1] ? limit[1] : SYNC_NUM_DEFAULT;
            if (result % syncNum === 0) {
                let newNum = result;
                const key = DATA_TRACK_PREFIX + eventId;
                const sync = this.storeApi.getSync(key);
                if (sync && sync.suc && sync.data) {
                    const local = JSON.parse(sync.data);
                    const localNum = dayStr === local[0] ? local[1] : 0;
                    newNum = Math.max(result, localNum);
                }
                this.eventIdNumObj[eventId] = [dayStr, newNum];
                this.storeApi.putSync(key, JSON.stringify([dayStr, newNum]));
            }
        }
        return result;
    }
    setLimitNum(eventId, num) {
        const dayStr = moment().format('YYYY-MM-DD');
        this.eventIdNumObj[eventId] = [dayStr, num];
        const limit = this.limitMap.has(eventId) && this.limitMap.get(eventId);
        const syncNum = limit && limit[1] ? limit[1] : 10;
        if (num % syncNum === 0) {
            const key = DATA_TRACK_PREFIX + eventId;
            const data = [dayStr, num];
            this.storeApi.putSync(key, JSON.stringify(data));
        }
    }
    clearAttributes() {
        window.DATracker.clear_attributes();
    }
    getAttributes() {
        return new Promise(res => {
            window.DATracker.current_attributes((properties) => {
                res(properties);
            });
        });
    }
    registerAttributes(properties) {
        window.DATracker.register_attributes(properties);
    }
    updateAttributes(properties) {
        try {
            window.DATracker.current_attributes(curProperties => {
                const newProperties = Object.assign(curProperties, properties);
                window.DATracker.register_attributes(newProperties);
            });
            const { domain, logginStatus, orgName, orgId, qiyeAccountId } = this.trackCommonOption;
            window.DATracker.oxpecker_set_product_profile({
                domain: properties.domain || domain,
                isLogin: properties.logginStatus || logginStatus,
                orgName: properties.orgName || orgName,
                orgId: properties.orgId || orgId,
                qiyeAccountId: properties.qiyeAccountId || qiyeAccountId,
            });
        }
        catch (err) {
            console.log(err);
        }
    }
    unregisterAttributes(prop) {
        window.DATracker.unregister_attributes(prop);
    }
    flush() {
        window.DATracker.oxpecker_flush();
    }
    setToken(token) {
        window.DATracker.oxpecker_set_token(token);
    }
    setNoLoggerUntil(noLoggerUntil) {
        console.log(noLoggerUntil);
    }
}
DataTrackerApiImp.keyDeviceUUID = config('browerDeviceUUID');
const dataTrackerApiImp = new DataTrackerApiImp();
api.registerLogicalApi(dataTrackerApiImp);
export default dataTrackerApiImp;
export const updateTrackerAttributes = dataTrackerApiImp.updateAttributes;
